import React from 'react';

const CustomWoowiiTalentCompanyButtonFooter = ({ groupType, buttonType, color }) => {
    return (
        <div className={`download-button-group ${groupType}`}>
            <a  href="/waiting-list-form" className={`woowii-hero-button-talento mb-5 download-button download-button-google ${buttonType}`}>
                <div className={`download-button-inner ${color}`}>
                    <div className="download-button-content">
                        <h3 className={`c-dark ls-2 ${color} ps-4 pe-4`}>WAITING LIST</h3>
                    </div>
                </div>
            </a>
            <a href="/request-demo" className={`download-button download-button-apple ${buttonType}`}>
                <div className={`download-button-inner ${color}`}>
                    <div className="download-button-content">
                        <h3 className={`c-dark ls-2 ${color} ps-4 pe-4`}>SOLICITAR DEMO</h3>
                    </div>
                </div>
            </a>
        </div>
    );
};

export default CustomWoowiiTalentCompanyButtonFooter;